import { useTranslation } from 'next-i18next';

import { Box, Flex, IconButton, Link, Text } from '@chakra-ui/react';

import { IconProps, IconsNocowanie } from '@nocowanie/icons';

import { SocialMediaProps } from './social-media.props';
import { defaultSocialMediaTranslation } from './social-media.translation.model';

export const SocialMedia = ({
    translationData = defaultSocialMediaTranslation,
    ...props
}: SocialMediaProps) => {
    const { t } = useTranslation('socialMedia');

    const iconConfig: IconProps = {
        fontSize: '2xl',
    };

    const SocialMediaData = [
        {
            url: t('facebook'),
            icon: <IconsNocowanie.Facebook {...iconConfig} />,
        },
        {
            url: t('youtube'),
            icon: <IconsNocowanie.Youtube {...iconConfig} />,
        },
        {
            url: t('instagram'),
            icon: <IconsNocowanie.Instagram {...iconConfig} />,
        },
    ];

    return (
        <Box {...props}>
            <Text
                fontSize={{
                    md: 'xl',
                }}
            >
                {translationData.followUs}
            </Text>
            <Flex
                mt={{
                    base: 3,
                    md: 4,
                }}
                gap={6}
            >
                {SocialMediaData.map((item, index) => (
                    <IconButton
                        asChild
                        key={index}
                        p={3}
                        color={'white'}
                        border={'1px solid #fff'}
                        borderRadius={'full'}
                        _hover={{
                            bg: 'white',
                            color: 'secondary.600',
                        }}
                        variant={'outline'}
                        colorPalette={'white'}
                    >
                        <Link href={item.url} target="_blank" rel="nofollow noopener">
                            {item.icon}
                        </Link>
                    </IconButton>
                ))}
            </Flex>
        </Box>
    );
};
